import { render, staticRenderFns } from "./PaginationMenu.vue?vue&type=template&id=dddea3a0&scoped=true&"
import script from "./PaginationMenu.vue?vue&type=script&lang=js&"
export * from "./PaginationMenu.vue?vue&type=script&lang=js&"
import style0 from "./PaginationMenu.vue?vue&type=style&index=0&id=dddea3a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddea3a0",
  null
  
)

export default component.exports